// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3cHCr","upload":"Small_upload__wiu5k","imageWrap":"Small_imageWrap__pdlMB","removeBtn":"Small_removeBtn__1bJxw"};